import CustomCard from '../../../../components/CustomCard';
import CustomTooltip from '../../../../components/CustomTooltip';
import {  IconClip } from '../../../../components/buttons/IconButtons';
import { downloadActionFile } from '../../../../Apis/functions';
import CustomFileCard from '../../../../components/CustomFileCard';
import NotInformation from "../../../../components/NotInformation";
import React from "react";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ReservationPolicyDocuments = (props) => {
    const { t, assets } = props;

    return (
        <>
            <CustomCard classCard='card-border-8px' classContent='p-0 overflow-hidden'>
                <div className='d-flex align-items-center p-3'>
                    <IconClip />
                    <div className='ml-2'>
                        <CustomTooltip
                            text={t('policy_documents')}
                            classes={'font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row'}
                            showIfTruncated={true}
                            placement={'top'}
                        />
                    </div>
                </div>
                <div className='border-bottom-shades-300' />
                { assets?.length === 0 ?
                    <div className='h-170px'>
                        <NotInformation text={t('no_documents_found')} card={true} className={"h-100"}
                                        classNameImage={"h-100px py-1"}/>
                    </div>
                    :
                    <div className='h-170px overflow-y-auto p-3'>
                        {assets?.map((e) => {
                            return (
                                <div className={'mt-2'}>
                                    <CustomFileCard
                                        Icon={e.Icon}
                                        title={e.name}
                                        subtitle={
                                            <p className={'justify-content-start d-flex ibl-font-w-400 fs-10px'}>
                                                {e.size}
                                            </p>
                                        }
                                        fileValue={e.filePath}
                                        buttonId={'btn_rpd_download_' + e.id}
                                        onClick={() => downloadActionFile(e.filePath)}
                                    />
                                </div>
                            );
                        })}
                    </div>
                }
            </CustomCard>
        </>
    );
};

export default ReservationPolicyDocuments;
